// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "71b5234a2cfdc8ce49a1" + ".chunk.js";
};